import Vue from 'vue'
import Child from './Child'
import Field from './Field'
import Sidebar from './layout/Sidebar'
import SidebarProfile from './layout/SidebarProfile'
import MerchantProfile from './layout/MerchantProfile'
import MerchantMenu from './layout/MerchantMenu'
import LanguageSelector from './layout/LanguageSelector'
import Subscriptions from './pages/dashboard/Subscriptions'
import ActivePaymentPlan from './pages/dashboard/ActivePaymentPlan'
import Accessory from './pages/dashboard/Accessory'
import SubscriptionDetails from './pages/dashboard/SubscriptionDetails'
import Transaction from './payment/Transaction'
import UpcomingTransaction from './payment/UpcomingTransaction'
import Card from './payment/Card'
import PaymentPlan from './payment/PaymentPlan'
import PaymentMethod from "./payment/PaymentMethod";
import UserTerms from './payment/UserTerms'
import PaymentTerms from './payment/PaymentTerms'
import NewSubscriptionModal from './subscription/NewSubscriptionModal'
import NewWaitlistModal from './waitlist/NewWaitlistModal'
import Service from './subscription/Service'
import ServiceFilters from './subscription/ServiceFilters'
import ServiceDetails from './subscription/ServiceDetails'
import ProfileSettings from './pages/profile/ProfileSettings'
import PrivacySettings from './pages/profile/PrivacySettings'
import DocumentationSettings from "./pages/profile/DocumentationSettings"
import AvailableBookings from './pages/booking/AvailableBookings'
import ReservedBookings from './pages/booking/ReservedBookings'
import NewBookingModal from './pages/booking/NewBookingModal'
import WinterPlaceModal from './pages/booking/WinterPlaceModal'
import AvailableProductsModal from './merchant/AvailableProductsModal'
import Alert from './notifications/Alert'
import Modal from './notifications/Modal'
import NotificationBell from './notifications/NotificationBell'
import ProfileSetup from './pages/setup/ProfileSetup'
import SocialNumberSetup from "./pages/setup/SocialNumberSetup.vue"
import CompanySetup from './pages/setup/CompanySetup'
import flatPickr from 'vue-flatpickr-component'
import SubscriptionModalContainer from './subscription/SubscriptionModalContainer'
import GlobalAnnouncement from './GlobalAnnouncement'

// Register the components
Vue.component(Child.name, Child)
Vue.component(Field.name, Field)
Vue.component(Sidebar.name, Sidebar)
Vue.component(SidebarProfile.name, SidebarProfile)
Vue.component(MerchantProfile.name, MerchantProfile)
Vue.component(MerchantMenu.name, MerchantMenu)
Vue.component(LanguageSelector.name, LanguageSelector)
Vue.component(Subscriptions.name, Subscriptions)
Vue.component(ActivePaymentPlan.name, ActivePaymentPlan)
Vue.component(Accessory.name, Accessory)
Vue.component(Transaction.name, Transaction)
Vue.component(UpcomingTransaction.name, UpcomingTransaction)
Vue.component(Card.name, Card)
Vue.component(PaymentPlan.name, PaymentPlan)
Vue.component(PaymentMethod.name, PaymentMethod)
Vue.component(UserTerms.name, UserTerms)
Vue.component(PaymentTerms.name, PaymentTerms)
Vue.component(SubscriptionDetails.name, SubscriptionDetails)
Vue.component(NewSubscriptionModal.name, NewSubscriptionModal)
Vue.component(NewWaitlistModal.name, NewWaitlistModal)
Vue.component(Service.name, Service)
Vue.component(ServiceFilters.name, ServiceFilters)
Vue.component(ServiceDetails.name, ServiceDetails)
Vue.component(ProfileSettings.name, ProfileSettings)
Vue.component(PrivacySettings.name, PrivacySettings)
Vue.component(DocumentationSettings.name, DocumentationSettings)
Vue.component(AvailableBookings.name, AvailableBookings)
Vue.component(ReservedBookings.name, ReservedBookings)
Vue.component(NewBookingModal.name, NewBookingModal)
Vue.component(WinterPlaceModal.name, WinterPlaceModal)
Vue.component(AvailableProductsModal.name, AvailableProductsModal)
Vue.component(Alert.name, Alert)
Vue.component(Modal.name, Modal)
Vue.component(NotificationBell.name, NotificationBell)
Vue.component(ProfileSetup.name, ProfileSetup)
Vue.component(SocialNumberSetup.name, SocialNumberSetup)
Vue.component(CompanySetup.name, CompanySetup)
Vue.component('flatPickr', flatPickr)
Vue.component(SubscriptionModalContainer.name, SubscriptionModalContainer)
Vue.component(GlobalAnnouncement.name, GlobalAnnouncement)



// WEBPACK FOOTER //
// ./src/components/index.js